/**
 * Advanced Category Management Dialog
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 * @author MattJS (mattjs@yext.com)
 */
goog.provide('yext.location.categories.AdvancedCategoryDialog');
goog.provide('yext.location.categories.AdvancedCategoryDialogDetails');

goog.require('yext.dialog');
goog.require('yext.notify');
goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');
goog.require('yext.location.categories.Categories');
goog.require('yext.storm.routesDEPRECATED');

/**
 * Advanced Category Management Dialog
 * @constructor
 */
yext.location.categories.AdvancedCategoryDialog = function(options) {
  this.options = options;
  this.$ctx = options.field;
  this.$link = options.link;
  this.isHealthcare = !!this.$ctx.find('.js-categories-field').data('isHealthcare');
  this.initialized = false;
  this.detailsByCategoryListId = {};
  this.labelsByCategoryListId = {};
  this.initialCategoriesCountByCategoryListId = {}; // Stores the initial state
  this.baseCategoriesListId = null;
  this.$submitBtn = {};

  this.onOverrideChange = options.onOverrideChange;

  this.bindActions();

  if (options.earlyInitializeDialog) {
    this.initialize(() => {
      this.setOverrideText();
      $(this).trigger('updated');
      this.$dialogContainer.dialog('close');
    });
  }
};

yext.location.categories.AdvancedCategoryDialog.prototype.bindActions = function() {
  var self = this;

  this.$link.on('click', function() {
    self.show();
  });
};

/**
 * Sets the Override text for the link
 */
yext.location.categories.AdvancedCategoryDialog.prototype.setOverrideText = function() {
  var linkText = '';
  var overriddenDetails = this.getOverriddenDetails();

  if (overriddenDetails.count > 0) {
    linkText = yext.msgn(
      '<1 Override>',
      '<{0} Overrides>',
      overriddenDetails.count);
  }

  if (this.onOverrideChange) {
    this.onOverrideChange(overriddenDetails.count);
  }

  this.$link.find('.js-advanced-category-override-text').text(linkText);
};

/**
 * Checks whether the Dialog has already been initialized to determine
 * whether it should show or initialize the dialog
 */
yext.location.categories.AdvancedCategoryDialog.prototype.show = function() {
  if (!this.initialized) {
    this.initialize();
    return;
  }

  $(this).trigger('open');
  this.showInternal();
};

/**
 * Show the Dialog if it has already been initialized on the page.
 */
yext.location.categories.AdvancedCategoryDialog.prototype.showInternal = function() {
  this.dialogObj.dialog().show();
};

/**
 * Bind actions and do general initialization of the dialog
 */
yext.location.categories.AdvancedCategoryDialog.prototype.bind = function() {
  this.bindLabelAction();
  this.bindButtons();
};

/**
 * sets the dialog containers
 */
yext.location.categories.AdvancedCategoryDialog.prototype.setContainers = function() {
  this.$sidebar = this.$ctx.find('.js-advanced-categories-dialog-sidebar');
  this.$submitBtn = this.$ctx.find('.js-submit-btn');
};

/**
 * bind event listener that triggers when the user clicks a label
 */
yext.location.categories.AdvancedCategoryDialog.prototype.bindLabelAction = function() {
  var $detailsList = this.$ctx.find('.js-publisher-details-list');
  var self = this;

  this.$sidebar.on('click', '.js-publisher-label', function() {
    var $this = $(this);
    var categoryListId = parseInt($this.data('category-list-id'));

    // set the selected view in the Sidebar
    self.$sidebar.find('.js-publisher-label').removeClass('selected');
    $this.addClass('selected');

    // show the publisher details with the same id
    $detailsList.find('.js-publisher-details').hide();
    self.detailsByCategoryListId[categoryListId].show();
  });
};

/**
 * Bind Button Actions on Dialog
 */
yext.location.categories.AdvancedCategoryDialog.prototype.bindButtons = function() {
  var $cancelBtn = this.$ctx.find('.js-cancel-btn');
  var self = this;

  this.$submitBtn.on('click', function() {
    var $btn = $(this);

    if ($btn.hasClass('disabled')) {
      return;
    }

    self.setOverrideText();
    $(self).trigger('updated');
    self.$dialogContainer.dialog('close');
  });

  $cancelBtn.on('click', function() {
    self.$dialogContainer.dialog('close');
    self.reset();
  });
};

/**
 * Bind Categories Search implementation for each publisher,
 * save them on a map based of categoryIds
 */
yext.location.categories.AdvancedCategoryDialog.prototype.initDetails = function() {
  this.detailsByCategoryListId = {};
  var self = this;

  this.baseCategoriesListId = this.$ctx.find('.js-base-publisher-category').data('categoryListId');

  this.$ctx.find('.js-publisher-details').each(function() {
    var $container = $(this);
    var details =
          new yext.location.categories.AdvancedCategoryDialogDetails($container, self.options);

    self.detailsByCategoryListId[details.categoryListId] = details;

    $(self.detailsByCategoryListId[details.categoryListId]).on('updated', function() {
      self.onDetailsUpdate(details);
    });
  });
};

/**
 * Action on AdvancedCaterforyDialogDetails Updated event
 * @param {yext.location.categories.AdvancedCategoryDialog} details details that had been updated
 */
yext.location.categories.AdvancedCategoryDialog.prototype.onDetailsUpdate = function(details) {
  var $publisherLabel = this.labelsByCategoryListId[details.categoryListId];
  var categoryCount = details.getCategoryCount();
  var isBaseList = this.isBaseCategoryList(details.categoryListId);

  $publisherLabel.find('.js-category-count').text(categoryCount);

  $publisherLabel.toggleClass('overridden', details.isOverridden() && !isBaseList)
    .toggleClass('no-categories', categoryCount === 0);

  this.$ctx.find('.js-submit-btn').removeClass('disabled');
};

/**
 * @return True if the categoryListId is the baseCategoryList
 */
yext.location.categories.AdvancedCategoryDialog.prototype.isBaseCategoryList = function(categoryListId) {
  return parseInt(this.baseCategoriesListId) === parseInt(categoryListId);
};

/**
 * @typedef OverriddenDetails
 * @type Object
 * @property {number} count the number of overridden categoriesLists
 * @property {boolean} indeterminate boolean indicating if list contains any indeterminate categories
 */
/**
 * Gets Overridden Count by iterating through all the details in the dialog
 * @returns {OverriddenDetails}
 *          Object containing the details of the overridden state
 */
yext.location.categories.AdvancedCategoryDialog.prototype.getOverriddenDetails = function() {
  var data = {
    count: 0,
    indeterminate: false,
  };
  var self = this;

  $.each(this.detailsByCategoryListId, function(key, details) {
    if (details.isIndeterminate()) {
      data.indeterminate = true;
    }

    if (details.isOverridden() && !self.isBaseCategoryList(details.categoryListId)) {
      data.count += 1;
    }
  });

  return data;
};

/**
 * Initializes all the publisher labels in the sidebar for later reference
 */
yext.location.categories.AdvancedCategoryDialog.prototype.initLabels = function() {
  var self = this;
  var $labels = this.$ctx.find('.js-advanced-categories-dialog-sidebar .js-publisher-label');

  $labels.each(function() {
    var categoryListId = $(this).data('categoryListId');
    self.labelsByCategoryListId[categoryListId] = $(this);
    self.initialCategoriesCountByCategoryListId[categoryListId] = $(this).find('.js-category-count').text();
  });

  // initialize no category text
  $labels.find('.js-no-category-tooltip').contextualHelp({
    event: 'hover',
    location: 'top',
  });
};

/**
 * Sets the dialog as initialized and runs ajax to fetch the Dialog template
 * @param {Function} successCallback
 * @suppress {deprecated}
 */
yext.location.categories.AdvancedCategoryDialog.prototype.initialize = function(successCallback) {
  this.initialized = true;
  yext.dialog.showProgressDialog();
  var self = this;
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));
  var defaultParamData = {
    locationSearchParam: locationSearchParam,
    templateId: this.getTemplateId(),
    clusterLocationId: this.getClusterLocationId(),
    isHealthcare: this.isHealthcare,
  };
  $.ajax({
    type: 'GET',
    url: this.getRoute(),
    data: this.getFullParams(defaultParamData),
    dataType: 'json',
    success: function(result) {
      self.template(result);
      yext.dialog.hideProgressDialog();
      successCallback && successCallback();
    },
    error: function(request, error) {
      // TODO(alipman): Update with more accurate error when server endpoint is connected
      // Talked about possibly having server send error message.
      yext.notify.showError(yext.msg('Unable to retrieve data'));
    },
  });
};

/**
 * Newer consumers of the module will provide the route in the options
 *
 * @return {string} AJAX route for ACM
 */
yext.location.categories.AdvancedCategoryDialog.prototype.getRoute = function() {
  if (this.options.route) {
    return this.options.route;
  }
  return yext.storm.routesDEPRECATED.LocationEdit.getAdvancedCategoriesJSON();
};

/**
 * Return full params data with optional extra params for loading the ACM dialog since different routes need different
 * params
 *
 * @param {!Object} Default param data
 * @return {Object} param data for loading the dialog with extra params
 */
yext.location.categories.AdvancedCategoryDialog.prototype.getFullParams = function(defaultData) {
  if (this.options.paramsForLoading) {
    return Object.assign(defaultData, this.options.paramsForLoading);
  }
  return defaultData;
};

/**
 * @return {number} If we are on template edit page or location add page applying a template return
 * the template ID
 */
yext.location.categories.AdvancedCategoryDialog.prototype.getTemplateId = function() {
  var $templateIdTemplateEdit = $('input[name="templateId"]');
  var $templateIdLocationAdd = $('.js-base-template-id');
  var $templateIdTemplateAdd = $('input[name="baseTemplateId"]');

  // If on template edit page return that template Id
  // Else return template Id on locationAddPage, will be null if not using a base template
  if ($templateIdTemplateEdit.length) {
    return $templateIdTemplateEdit.val();
  }
  if ($templateIdLocationAdd.length) {
    return $templateIdLocationAdd.val();
  }
  if ($templateIdTemplateAdd.length) {
    return $templateIdTemplateAdd.val();
  }
  return undefined;
};

/**
 * @return {number} If we are on location add page return the cluster location ID
 */
yext.location.categories.AdvancedCategoryDialog.prototype.getClusterLocationId = function() {
  var $clusterLocationId = $('input[name="clusterLocationId"]');
  if ($clusterLocationId.length) {
    return $clusterLocationId.val();
  }
  return undefined;
};

/**
 * Populates the template with the date given in the response
 * @param  {!Object} response object containing the template date and populated it according to the data
 * @suppress {deprecated}
 */
yext.location.categories.AdvancedCategoryDialog.prototype.template = function(response) {
  // get the html content
  var renderedHtml = response['html'];
  if (renderedHtml.length <= 0) {
    yext.notify.showError(yext.msg('Failed to load Advanced Category Management Dialog. Please refresh and try again'));
    return;
  }

  // build the dialog
  this.build(renderedHtml);

  // show the dialog
  this.dialogObj = this.$dialogContainer.dialog({
    title: yext.msg('Advanced Category Management'),
    autoOpen: true,
    modal: true,
    draggable: false,
    resizable: false,
    minWidth: '685',
  });
};

/**
 * Get data from the advancedCategoryDialog
 * @return {!Object} json Data for the categories
 */
yext.location.categories.AdvancedCategoryDialog.prototype.get = function() {
  var categories = [];
  var self = this;

  $.each(this.detailsByCategoryListId, function(categoryListId, details) {
    // Don't add the base categories to the overrides
    if (self.baseCategoriesListId == categoryListId) {
      return;
    }

    categories.push(details.get());
  });

  return categories;
};

/**
 * Reconcile all of the category lists with category server after saving
 *
 * @param {!Object} field Serialized CategoriesView Java object
 */
yext.location.categories.AdvancedCategoryDialog.prototype.reconcile = function(field) {
  this.getBaseCategories().reconcile(field);
  for (var i = 0; i < field.overrideCategories.length; i++) {
    var overrides = field.overrideCategories[i];
    var detailsPanel = this.detailsByCategoryListId[overrides.categoryListId];

    if (detailsPanel != null) {
      detailsPanel.reconcile(overrides);

      var numMappedCategories = overrides.mappedCategories.length;
      if (numMappedCategories) {
        this.labelsByCategoryListId[overrides.categoryListId].find('.js-category-count').text(numMappedCategories);
        this.initialCategoriesCountByCategoryListId[overrides.categoryListId] = numMappedCategories;
      } else {
        this.initialCategoriesCountByCategoryListId[overrides.categoryListId] = detailsPanel.getCategoryCount();
      }
    }
  }
};

/**
 * Builds the dialog template from the rendered json and append it to the body of the DOM, shows the dialog by default
 * @param {string} html for the dialog
 */
yext.location.categories.AdvancedCategoryDialog.prototype.build = function(html) {
  this.$dialogContainer = $(html);
  $('body').append(this.$dialogContainer);
  this.$ctx = this.$dialogContainer;
  this.setContainers();
  this.bind();
  this.initLabels();
  this.initDetails();
  $(this).trigger('open');
};

/**
 * Resetting the dialog to original state
 */
yext.location.categories.AdvancedCategoryDialog.prototype.reset = function() {
  var self = this;

  // update sidebar publishers to original state (base selected by default)
  this.$sidebar.find('.js-publisher-label').removeClass('selected');
  this.labelsByCategoryListId[this.baseCategoriesListId].click();
  $.each(this.detailsByCategoryListId, function(categoryListId, details) {
    details.reset();
    self.onDetailsUpdate(details);
    self.labelsByCategoryListId[categoryListId].find('.js-category-count').text(
      self.initialCategoriesCountByCategoryListId[details.categoryListId]);
  });
  this.$submitBtn.addClass('disabled');
  this.setOverrideText();
};

/**
 * Store the values of all lists on ACM
 */
yext.location.categories.AdvancedCategoryDialog.prototype.storeValues = function() {
  $.each(this.detailsByCategoryListId, function(categoryListId, details) {
    details.storeValues();
  });
};

/**
 * @return {yext.location.categories} the categories instance for the base Category
 */
yext.location.categories.AdvancedCategoryDialog.prototype.getBaseCategories = function() {
  return this.detailsByCategoryListId[this.baseCategoriesListId].categoryList;
};

/**
 * The Details for the AdvancedCategoryDialog
 * @constructor
 * @param {!jQuery} $ctx the details container
 */
yext.location.categories.AdvancedCategoryDialogDetails = function($ctx, options) {
  this.$ctx = $ctx;
  this.$indeterminate = this.$ctx.find('.js-indeterminate-container');

  this.countryCodes = [];
  if (options) {
    this.countryCodes = options.countryCodes;
    this.entityTypeId = options.entityTypeId;
    this.isUserEmployee = options.isUserEmployee;
  }
  this.categoryListId = this.$ctx.data('categoryListId');
  this.baseCategoryList = this.$ctx.data('baseCategoryList');
  this.publisherName = this.$ctx.data('publisherName');
  this.overrideStatusIndeterminate = !!this.$ctx.data('overrideStatusIndeterminate');
  this.hasMappedCategories = !!this.$ctx.data('hasMappedCategories');
  this.categoryList = this.createCategories();
  this.mappedCategories = this.$ctx.data('mappedCategories');

  this.storeValues();
  this.bind();
  this.render();
};

/**
 * - Sets the translated text for the Override Checkbox and tooltip initialize tooltip
 * - Bind actions for triggering overriding edit view
 * - Listen to changes on the categorySearcher
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.bind = function() {
  var self = this;

  this.$ctx.find('.js-publisher-tooltip').contextualHelp({
    event: 'hover',
    location: 'top',
  });

  var $checkbox = this.$ctx.find('.js-override-checkbox');
  $checkbox.on('click, input, change', function() {
    var checked = $checkbox.prop('checked');
    if (checked) {
      self.categoryList.reconcile({
        'categories': self.mappedCategories.slice(),
      });
    } else {
      self.categoryList.reconcile({
        'categories': [],
      });
    }
    self.toggleOverrides(checked);
  });

  this.$indeterminate.find('.js-indeterminate-link').click(function() {
    self.overrideStatusIndeterminate = false;
    $checkbox.prop('checked', false).trigger('change');
    self.render();
  });

  $(this.categoryList).on('updated', function() {
    self.render();
    self.onUpdate();
  });
};

yext.location.categories.AdvancedCategoryDialogDetails.prototype.onUpdate = function() {
  $(this).trigger('updated');
};

yext.location.categories.AdvancedCategoryDialogDetails.prototype.render = function() {
  var isOverridden = this.isOverridden();
  var showNoCategories = !isOverridden && !this.hasMappedCategories && !this.overrideStatusIndeterminate;
  var showOverrideCheckbox = this.hasMappedCategories && !this.overrideStatusIndeterminate;

  this.$indeterminate.toggleClass('d-none', !this.overrideStatusIndeterminate);
  this.$ctx.find('.js-override-checkbox-view').toggleClass('d-none', !showOverrideCheckbox);
  this.$ctx.find('.js-no-categories-container').toggleClass('d-none', !showNoCategories);
};

/**
 * @param {boolean} show
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.toggleOverrides = function(show) {
  if (this.overrideStatusIndeterminate) {
    this.$ctx.find('.js-view-mode').toggleClass('d-none', true);
    this.$ctx.find('.js-edit-mode').toggleClass('d-none', true);
  } else {
    this.$ctx.find('.js-view-mode').toggleClass('d-none', show);
    this.$ctx.find('.js-edit-mode').toggleClass('d-none', !show);
  }
};

/**
 * Sets the override checkbox checked property
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.setOverrideCheckbox = function() {
  this.$ctx.find('.js-override-checkbox').prop('checked', this.isOverridden());
};

/**
 * creates category searcher
 * @return {yext.location.categories} a new instance of a yext locaton categories
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.createCategories = function() {
  return new yext.location.categories.Categories(this.$ctx, {
    'categorySearchUrl': '/s/_categories/search2',
    'searchParameters': {
      'categoryListId': this.categoryListId,
      'countryCodes': this.countryCodes,
      'entityTypeId': this.entityTypeId,
      'excludeAdditionalChainCategories': !this.isUserEmployee,
    },
  });
};

/**
 * get the data for the overriden categories
 * @return {!Object} Details about the override categories
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.get = function() {
  var data = {
    'categoryListId': this.categoryListId,
    'categoryListName': this.publisherName,
    'indeterminate': this.isIndeterminate(),
    'categories': [],
  };

  if (this.overrideStatusIndeterminate) {
    data['indeterminate'] = true;
  }

  if (this.isOverridden()) {
    $.extend(data, this.categoryList.getData());
  }

  return data;
};

/**
 * Store Dialog Details so they can be restored on reset
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.storeValues = function() {
  this.categoryList.storeValues();
  this.storedOverrideStatusIndeterminate = this.overrideStatusIndeterminate;
};

/**
 * Reset the dialog details to the original state
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.reset = function() {
  this.overrideStatusIndeterminate = this.storedOverrideStatusIndeterminate;
  this.categoryList.reset();
  this.render();
  this.setOverrideCheckbox();
  this.toggleOverrides(this.isOverridden());
};

/**
 * Show the category Details
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.show = function() {
  this.$ctx.show();
};

/**
 * Reconcile with the category server after saving
 *
 * @param {!Array.<Object>} overrides List of serialized OverrideCategoriesView Java objects for this publisher
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.reconcile = function(overrides) {
  this.overriddenIndeterminate = overrides['overriddenIndeterminate'];
  this.categoryList.reconcile(overrides);

  this.storeValues();
  this.renderMappedCategories(overrides.mappedCategories);
  this.setOverrideCheckbox();
  this.toggleOverrides(this.isOverridden());
};

/**
 * @return True if there are category overrides on this list
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.isOverridden = function() {
  return this.getCategoryCount() > 0 || this.isIndeterminate() || this.overrideStatusIndeterminate;
};

/**
 * @return True if the category selections for this list are indeterminate
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.isIndeterminate = function() {
  return this.categoryList.indeterminate;
};

/**
 * @return {number} The Number of Categories the view has
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.getCategoryCount = function() {
  return this.categoryList.getCheckedShownCategories();
};

/**
 * Render the mapped category list
 *
 * @param {!Array.<Object>} mappedCategories List of mapped categories for this publisher
 */
yext.location.categories.AdvancedCategoryDialogDetails.prototype.renderMappedCategories = function(mappedCategories) {
  var $list = this.$ctx.find('.js-mapped-categories-list');
  var categoryNames = [];
  for (var i = 0; i < mappedCategories.length; i++) {
    categoryNames.push(mappedCategories[i].fullName);
  }
  $list.empty();
  if (categoryNames.length > 0) {
    $list.append('<li>' + categoryNames.join('</li><li>') + '</li>');
  }
};
